<template>
  <div>
    <HeaderShadow></HeaderShadow>
    <Logo></Logo>

    <ErrorBox
      v-if="errorHeading || errorContent"
      :heading="errorHeading"
      :content="errorContent"
      :fixed="errorFixed"
      @closeError="
        errorHeading = '';
        errorContent = '';
      "
    ></ErrorBox>

    <div class="bg-white dark:bg-nucleus-darkerBlue p-6">
      <div
        v-if="status === 'verifying'"
        class="text-center text-xl p-10 text-nucleus-grey"
      >
        {{ $t("pages.verify.titleVerifying") }}
      </div>

      <div v-if="details && status === 'verifyPhone'">
        <div class="text-xl mb-6 text-nucleus-grey font-bold">
          {{ $t("pages.verify.title") }}
        </div>
        <div class="font-bold">
          {{ details.user }}
        </div>
        <div
          v-html="$t('pages.verify.description', { tenant: details.tenant })"
        ></div>
        <div class="mt-4 mb-8">
          {{ $t("pages.verify.partialPhoneNumber") }}
          <span class="font-bold">{{ partialPhoneNumber }}</span>
        </div>
      </div>

      <form
        v-if="status === 'verifyPhone'"
        @submit.prevent="verifyCodeRemoteUser"
      >
        <Input
          id="code"
          v-model:value="code"
          input-type="number"
          :label="$t('inputs.verificationCodeBasic.label')"
          :max-length="inputMaxLengths.code"
          :placeholder="$t('inputs.verificationCodeBasic.placeholder')"
        />

        <Button
          type="submit"
          :name="$t('buttons.verify')"
          class="mb-5"
        ></Button>

        <div
          class="inline text-nucleus-primaryBlue hover:text-nucleus-primaryMouseOver underline transition text-sm cursor-pointer"
          @click="verifyRemoteUser()"
        >
          {{ $t("pages.verify.resendSMS") }}
        </div>
      </form>
      <div v-if="status === 'verifySuccess'" class="text-center">
        {{ $t("pages.verify.successful") }}
      </div>
      <div v-if="status === 'alreadyVerified'" class="text-center">
        {{ $t("pages.verify.alreadyVerified") }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import HeaderShadow from "@/components/utils/HeaderShadow.vue";
import Logo from "@/components/utils/Logo.vue";
import Input from "@/components/utils/Input.vue";
import Button from "@/components/utils/Button.vue";
import ErrorBox from "@/components/utils/ErrorBox.vue";

import InputMaxLengths from "@/store/data/inputMaxLengths.json";
import { getLocalisedError } from "@/utils/apiUtils";

@Options({
  components: {
    HeaderShadow,
    Logo,
    Input,
    Button,
    ErrorBox,
  },
  data() {
    return {
      status: "verifying",
      code: "",
      details: {},
      partialPhoneNumber: "",
      errorHeading: "",
      errorContent: "",
      errorFixed: true,
      inputMaxLengths: InputMaxLengths[0],
    };
  },
  mounted() {
    this.getRemoteUserDetails();
  },
  methods: {
    getRemoteUserDetails() {
      const token = this.$route.query.token;
      const userId = this.$route.query.userId;

      console.log(token, userId);

      this.$store
        .dispatch("getRemoteUserDetails", { token, userId })
        .then((response: Record<string, any>) => {
          if (response) {
            this.details = response.data;
            this.verifyRemoteUser();

            this.errorHeading = "";
            this.errorContent = "";
            console.log("Details", response.data);
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
    verifyRemoteUser() {
      const token = this.$route.query.token;
      const userId = this.$route.query.userId;

      this.$store
        .dispatch("sendCodeRemoteUser", { token, userId })
        .then((response: Record<string, any>) => {
          if (response) {
            this.status = "verifyPhone";
            this.partialPhoneNumber = response.data.partialPhoneNumber;

            this.errorHeading = "";
            this.errorContent = "";
            console.log("Send code", response);
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
    verifyCodeRemoteUser() {
      const token = this.$route.query.token;
      const userId = this.$route.query.userId;
      const code = this.code;

      this.$store
        .dispatch("verifyCodeRemoteUser", { token, userId, code })
        .then((response: Record<string, unknown>) => {
          if (response) {
            this.status = "verifySuccess";
            this.errorHeading = "";
            this.errorContent = "";
            console.log("Verify code", response);
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
  },
})
export default class Home extends Vue {}
</script>
